import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { outreachAction } from '@/lib/outreach';

/**
 * The basic app « Prospection » (03/11/2026): opens the workspace's own,
 * created on the first visit (one per workspace, chosen by the server).
 */
export const ProspectionStartPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);

  const open = () => {
    setError(null);
    void outreachAction<{ key: string }>({ action: 'create_prospecting_app', title: 'Prospection' })
      .then((app) => navigate(`/apps/${encodeURIComponent(app.key)}`, { replace: true }))
      .catch((cause: unknown) => setError(cause instanceof Error ? cause.message : 'La prospection n’a pas pu s’ouvrir.'));
  };

  useEffect(() => {
    // Once, even under React's double effects in development: the server keeps one app per workspace anyway.
    if (started.current) return;
    started.current = true;
    open();
  });

  return (
    <div className="mx-auto max-w-6xl px-5 py-7 sm:px-8 lg:py-9">
      {error ? (
        <div role="alert" className="space-y-3">
          <p className="text-sm text-domino-inkSoft">{error}</p>
          <Button variant="secondary" onClick={open}>Réessayer</Button>
        </div>
      ) : (
        <div className="space-y-4" aria-busy="true">
          <div className="h-8 w-56 animate-pulse rounded-lg bg-domino-warm" />
          <div className="h-4 w-80 animate-pulse rounded bg-domino-warm" />
          <div className="h-64 animate-pulse rounded-2xl bg-domino-warm" />
        </div>
      )}
    </div>
  );
};
